import { render, staticRenderFns } from "./ExaminationList.vue?vue&type=template&id=c308ba04&scoped=true"
import script from "./ExaminationList.vue?vue&type=script&lang=js"
export * from "./ExaminationList.vue?vue&type=script&lang=js"
import style0 from "./ExaminationList.vue?vue&type=style&index=0&id=c308ba04&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c308ba04",
  null
  
)

export default component.exports